// 독립 빌드하는 공개/관리자 SPA에서 동일한 전송 계약을 사용한다.
function clean (value, max = 4000) {
  return String(value || '')
    .replace(/(https?:\/\/[^\s?#]+)[?#][^\s)]*/g, '$1')
    .replace(/\b(Bearer)\s+\S+/gi, '$1 [숨김]')
    .replace(/((?:password|passwd|token|secret|authorization)\s*[:=]\s*)[^\s,;]+/gi, '$1[숨김]')
    .slice(0, max)
}

export function installBrowserErrors (app, source, { send = (...args) => window.fetch(...args) } = {}) {
  const previous = app.config.errorHandler
  const recent = new Map()
  let windowStart = Date.now()
  let count = 0
  const report = (error, kind, info = '') => {
    try {
      const now = Date.now()
      if (now - windowStart >= 60000) { count = 0; windowStart = now; recent.clear() }
      const message = clean(error?.message || (typeof error === 'string' ? error : '브라우저 실행 오류'), 1000)
      const stack = clean(error?.stack, 5000)
      const key = message + stack
      if (count >= 20 || (recent.has(key) && now - recent.get(key) < 10000)) return
      recent.set(key, now)
      count++
      const body = JSON.stringify({
        source, kind, message, stack,
        route: window.location.pathname.slice(0, 255),
        info: clean(info, 500)
      })
      // 인증 토큰/쿠키/요청 본문을 전송하지 않고 전송 실패도 다시 보고하지 않는다.
      Promise.resolve(send('/api/v1/browser-errors', {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' }, body
      })).catch(() => {})
    } catch (_) { /* 관제 실패가 화면에 영향을 주지 않는다. */ }
  }
  const vueHandler = (error, instance, info) => {
    report(error, 'vue', info)
    if (previous) previous(error, instance, info)
  }
  const onError = event => {
    // 리소스 로딩 실패는 제외하고 JavaScript 실행 오류만 수집한다.
    if (event.error || event.message) report(event.error || event.message, 'javascript')
  }
  const onRejection = event => report(event.reason, 'promise')
  app.config.errorHandler = vueHandler
  window.addEventListener('error', onError)
  window.addEventListener('unhandledrejection', onRejection)
  return () => {
    if (app.config.errorHandler === vueHandler) app.config.errorHandler = previous
    window.removeEventListener('error', onError)
    window.removeEventListener('unhandledrejection', onRejection)
  }
}

